import { render, staticRenderFns } from "./ProjectEdit.vue?vue&type=template&id=43b8772d&scoped=true&"
import script from "./ProjectEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEdit.vue?vue&type=style&index=0&id=43b8772d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b8772d",
  null
  
)

export default component.exports